/* @ngInject */
const myTitle = (
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myLabel: '=',
      myStyle: '=?',
      myLevel: '=?',
      enableStrong: '=?',
    },

    template: require('./myTitle.html'),

    /* @ngInject */
    controller: ($scope, userService, utils) => {
      if (valueHandler.isNull($scope.level)) {
        $scope.level = 1
      }
    },
    link: (scope, element, attrs, ctrl) => {

    },
  }
}

export default myTitle



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/titles/myTitle.js